import { StaleBranches } from '../../../models/StaleBranches/index';

export enum Type {
  SET_STALE_BRANCHES = 'PROJECT_DASHBOARD/STALE_BRANCHES/SET_STALE_BRANCHES',
  RESET = 'PROJECT_DASHBOARD/STALE_BRANCHES/RESET',
}

interface Action<T> {
  type: T;
}

export interface SetStaleBranches extends Action<Type.SET_STALE_BRANCHES> {
  data?: StaleBranches;
}

export interface Reset extends Action<Type.RESET> {}

type Actions = SetStaleBranches | Reset;

export interface State {
  isLoading: boolean;
  data?: StaleBranches;
}

export const initialState: State = {
  isLoading: true,
  data: undefined,
};

export default (state = initialState, action: Actions): State => {
  switch (action.type) {
    case Type.SET_STALE_BRANCHES:
      return { ...state, data: action.data, isLoading: false };
    case Type.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export const actions = {
  setStaleBranches: (data: StaleBranches | undefined): SetStaleBranches => ({
    type: Type.SET_STALE_BRANCHES,
    data,
  }),
  reset: (): Reset => ({
    type: Type.RESET,
  }),
};
